"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _expander = _interopRequireDefault(require("../expander"));
var _excluded = ["initiallyExpanded", "renderToggle"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A simplified interface for the `Expander` component. Renders a `toggle` element and `Expander`
 * containing passed in children. `SimpleExpander` toggles the expanded state when the `toggle` is
 * clicked, and handles ARIA attributes appropriately.
 *
 * All props applied to the component are passed down to the underlying `Expander`, allowing for
 * usage of that component's prop API.
 *
 * `SimpleExpander` includes three methods to change the current expanded state of the component.
 * If you need to programmatically change the expanded state, assign the `SimpleExpander` to a ref
 * and call these methods from the parent component.
 *
 * - `openExpander()`
 * - `closeExpander()`
 * - `toggleExpander()`
 */
var SimpleExpander = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$initiallyExpande = _ref.initiallyExpanded,
    initiallyExpanded = _ref$initiallyExpande === void 0 ? false : _ref$initiallyExpande,
    _ref$renderToggle = _ref.renderToggle,
    renderToggle = _ref$renderToggle === void 0 ? function () {} : _ref$renderToggle,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(initiallyExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var expanderId = (0, _uniqueId2["default"])('simpleExpander');
  var toggleExp = function toggleExp() {
    setIsExpanded(!isExpanded);
  };
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      toggleExpander: function toggleExpander() {
        toggleExp();
      },
      openExpander: function openExpander() {
        setIsExpanded(true);
      },
      closeExpander: function closeExpander() {
        setIsExpanded(false);
      }
    };
  }, []);
  var Toggle = function Toggle() {
    var toggle = renderToggle(isExpanded);
    return /*#__PURE__*/_react["default"].cloneElement(toggle, {
      'aria-expanded': isExpanded,
      'aria-controls': isExpanded ? expanderId : null,
      onClick: toggleExp
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(Toggle, null), /*#__PURE__*/_react["default"].createElement(_expander["default"], _extends({
    id: expanderId,
    isExpanded: isExpanded
  }, otherProps)));
});
SimpleExpander.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,
  /**
   * The expanded state of the component when it is initially rendered.
   */
  initiallyExpanded: _propTypes["default"].bool,
  /**
   * A callback to render a toggle element. Receives the current `isExpanded` state of the
   * component as a parameter.
   */
  renderToggle: _propTypes["default"].func.isRequired
} : {};
var _default = exports["default"] = SimpleExpander;